
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"12","viewBox":"0 0 88 109","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.885.097a3.984 3.984 0 00-2.825 1.217 4.013 4.013 0 00-1.124 2.871v90.438L6.849 61.418a3.983 3.983 0 00-3.284-1.21 3.994 3.994 0 00-3.344 2.668 4.015 4.015 0 00.975 4.174L41.1 107.096a3.984 3.984 0 005.653 0L86.656 67.05a4.014 4.014 0 001.225-3.966 3.998 3.998 0 00-2.936-2.925 3.982 3.982 0 00-3.942 1.26L47.916 94.622V4.185a4.013 4.013 0 00-1.153-2.9A3.983 3.983 0 0043.885.097z","fill":"#4FA2B7","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/cable_menu/cable_south.svg